import { useState, useEffect } from "react";

export default function ReadMore({ children, expand= false }) {

    const [expanded, setExpanded] = useState(expand);
    const hasChildren = Boolean(children);

    // Sync with parent
    useEffect(() => {
        if (expand !== undefined) {
            setExpanded(expand);
        }
    }, [expand]);

    return (
        <>
            {expanded && hasChildren && children}

            {(!expanded || !hasChildren) && (
                <button
                    onClick={() => setExpanded(true)}
                    className="inline-flex items-center gap-2 px-4 py-2 bg-[#1C3353] text-white rounded-lg font-medium transition-all duration-300 hover:bg-gradient-to-b hover:from-[#F6D28B] hover:to-[#F1C169] hover:text-[#1C3353] hover:shadow-lg hover:shadow-yellow-500/30 group mx-auto"
                >
                    Read more
                    <span className="transition-transform duration-300 group-hover:translate-x-1">→</span>
                </button>
            )}
        </>
    );
}
